<template>
  <transition>
    <div v-if="isOpen && isHaveRights"
         class="translation-report"
         :class="{'dragged' : isDragged}"
         ref="translationReport">
      <div class="translation-report__title" ref="translationReportTitle">
        {{ $t('translation_report.title') }}
      </div>
      <div class="translation-report__content">
        <div v-if="!auth" class="translation-report__item">
          <div class="translation-report__info">{{ $t('translation_report.name') }}:</div>
          <input
            class="translation-report__value"
            v-model="name"
            @blur="$v.name.$touch"
            autocomplete="family-name"
          />
          <div class="translation-report__error" v-if="$v.name.$error">
            <template v-if="!$v.name.required">
              {{ $t('blank_field_error') }}
            </template>
          </div>
        </div>
        <div v-if="!auth" class="translation-report__item">
          <div class="translation-report__info">{{ $t('translation_report.email') }}:</div>
          <input
            class="translation-report__value"
            v-model="email"
            @blur="$v.email.$touch"
            autocomplete="email"
          />
          <div class="translation-report__error" v-if="$v.email.$error">
            <template v-if="!$v.email.required">
              {{ $t('blank_field_error') }}
            </template>
            <template v-if="!$v.email.email">
              {{ $t('invalid_email') }}
            </template>
          </div>
        </div>
        <div class="translation-report__item">
          <div class="translation-report__info">{{ $t('translation_report.wrong_text') }}:</div>
          <div class="translation-report__value">{{ text }}</div>
        </div>
        <div class="translation-report__item">
          <div class="translation-report__info">{{ $t('translation_report.correct_text') }}:</div>
          <textarea
            class="translation-report__textarea"
            @blur="$v.correctText.$touch"
            v-model="correctText"
          ></textarea>
          <div class="translation-report__error" v-if="$v.correctText.$error">
            <template v-if="!$v.correctText.required">
              {{ $t('blank_field_error') }}
            </template>
          </div>
        </div>
        <Button class="translation-report__btn"
                @click.native="submit()"
                :is-disabled="$v.$invalid"
        >
          {{ $t('translation_report.submit') }}
        </Button>
      </div>
      <div class="translation-report__close" @click="close"></div>
    </div>
  </transition>
</template>
<script>
import html2canvas from 'html2canvas'
import Button from '@/components/inputs/Button.vue'
import { mapState } from 'vuex'
import { email, required } from 'vuelidate/lib/validators'
import api from '@/api'
export default {
  name: 'TranslationReport',
  components: {
    Button
  },
  data () {
    return {
      isOpen: false,
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      isDragged: false,
      name: '',
      email: '',
      text: '',
      correctText: '',
      screenshot: null,
      url: '',
      isHaveRights: window.userRights?.custom_feedback
    }
  },
  computed: {
    ...mapState({
      auth: state => state.user.auth
    })
  },
  validations () {
    let validationRules = {
      correctText: {
        required
      }
    }
    if (!this.auth) {
      validationRules.email = {
        email, required
      }
      validationRules.name = {
        required
      }
    }
    return validationRules
  },
  methods: {
    resetData () {
      this.name = ''
      this.email = ''
      this.text = ''
      this.correctText = ''
      this.screenshot = null
      this.url = ''
    },
    submit () {
      const formData = new FormData()
      if (this.name) {
        formData.append('name', this.name)
      }
      if (this.email) {
        formData.append('email', this.email)
      }
      formData.append('description', this.correctText)
      formData.append('selected_text', this.text)
      formData.append('url', this.url)
      const image = this.dataURIToBlob(this.screenshot)
      formData.append('screenshot', image)
      api.report
        .sendData(formData)
        .finally(() => {
          this.close()
        })
    },
    dataURIToBlob (base64Data) {
      // Split the dataURI into parts (data type and base64 data)
      const contentType = base64Data.split(',')[0].replace(/^data:image\/\w+;base64,/, '')
      const byteString = atob(base64Data.split(',')[1])

      // Create a new array buffer
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const uint8Array = new Uint8Array(arrayBuffer)

      // Convert base64 string to byte array
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }

      // Create the Blob object
      return new Blob([arrayBuffer], { type: contentType })
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.resetData()
      this.isOpen = false
    },
    dragElement () {
      if (this.$refs.translationReportTitle) {
        this.$refs.translationReportTitle.onmousedown = this.dragMouseDown
      }
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
      this.isDragged = false
    },
    elementDrag (e) {
      e.preventDefault()
      // calculate the new cursor position:
      this.pos1 = this.pos3 - e.clientX
      this.pos2 = this.pos4 - e.clientY
      this.pos3 = e.clientX
      this.pos4 = e.clientY
      // set the element's new position:
      this.$refs.translationReport.style.top = (this.$refs.translationReport.offsetTop - this.pos2) + 'px'
      this.$refs.translationReport.style.left = (this.$refs.translationReport.offsetLeft - this.pos1) + 'px'
    },
    dragMouseDown (e) {
      this.isDragged = true
      e.preventDefault()
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX
      this.pos4 = e.clientY
      document.onmouseup = this.closeDragElement
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag
    },
    keypressListener (e) {
      if (e.ctrlKey && (e.code === 'Enter' || e.code === 'NumpadEnter') && (e.key === '\n' || e.key === 'Enter')) {
        this.open()
      }
    },
    getSelectionText () {
      if (this.isHaveRights) {
        const selectionObj = window.getSelection()
        const ifSelectInComponent = selectionObj.focusNode?.parentElement?.className?.includes('translation-report')
        if (window.getSelection().toString() && window.getSelection().toString() !== this.text && !ifSelectInComponent) {
          this.text = window.getSelection().toString()
        }
      }
    },
    captureScreenshot () {
      if (this.isHaveRights) {
        let selectedElement
        if (window.getSelection().toString()) {
          const selection = window.getSelection()
          const selectionRange = selection.getRangeAt(0) // Get the first range (assuming single selection)
          selectedElement = selectionRange.startContainer.parentElement // Get the parent element of the selection start
          selectedElement.classList.add('highlight-selection')
        }
        html2canvas(document.body).then(canvas => {
          const base64image = canvas.toDataURL('image/png')
          this.screenshot = base64image
          if (selectedElement) {
            selectedElement.classList.remove('highlight-selection')
          }
        })
      }
    }
  },
  mounted () {
    window.addEventListener('keypress', this.keypressListener)
    document.addEventListener('mouseup', this.getSelectionText)
    this.isHaveRights = window.userRights?.custom_feedback
  },
  destroyed () {
    window.removeEventListener('keypress', this.keypressListener)
    document.removeEventListener('mouseup', this.getSelectionText)
  },
  watch: {
    text: {
      handler (after, before) {
        // this.captureScreenshot()
      },
      deep: true
    },
    isOpen (val) {
      if (val && this.isHaveRights) {
        this.$nextTick(() => {
          // this.getSelectionText()
          this.dragElement()
          this.url = window.location.href
          this.captureScreenshot()
          if (!this.text) {
            this.captureScreenshot()
          }
        })
      }
    },
    auth () {
      this.isHaveRights = window.userRights?.custom_feedback
    }
  }
}
</script>
<style lang="sass">
.highlight-selection
  background-color: lightblue
</style>
<style scoped lang="sass">
.translation-report
  position: fixed
  left: 98%
  top: 98%
  transform: translate(-100%, -100%)
  z-index: 10
  background-color: #fff
  width: 450px
  max-width: 80vw
  box-shadow: 0 0 1px 2px #e7e5e5
  &.dragged
    .translation-report__title
      cursor: move
  &__btn
    margin: 0 auto
  &__error
    font-size: 12px
    margin-bottom: 10px
    color: #ff2f00
    margin-top: 5px
  &__textarea
    width: 100%
    border: none
    border-radius: 0
    font-size: 14px
    outline: none
    margin-top: 6px
    height: 50px
    padding: 5px
  &__item
    margin-bottom: 16px
  &__info
    font-size: 14px
    font-weight: 500
    margin-bottom: 3px
  &__value
    font-size: 14px
    width: 100%
    border: none
    outline: none
    max-height: 150px
    overflow-y: auto
    &:is(input)
      height: 30px
      padding: 0 5px
  &__close
    position: absolute
    right: 12px
    top: 9px
    width: 20px
    height: 20px
    background: #f9f9f9 url('/img/svgo/header/close-btn.svg') no-repeat center
    cursor: pointer
    &:hover
      background: #e1e1e1 url('/img/svgo/header/close-btn.svg') no-repeat center
  &__title
    padding: 10px
    font-size: 14px
    font-weight: 500
    cursor: grab
  &__content
    background-color: #f7f5f5
    padding: 10px
</style>
